<template>
  <div class="marketing-setting" :class="domain.shared">
    <div v-if="!settingUtm && !settingSurvey"
         class="select-segment">
      <div class="select-header">
        <i class="icon icon--close-size16"
           @click="onCloseLayer"></i>

        <div class="select-title">
          {{ $t('journey.targeting.step0.title') }}
        </div>
        <div class="select-description">
          {{ $t('journey.targeting.step0.description') }}
        </div>
      </div>
      <div class="select-body">
        <button :class="{ active: journeyOptions.utm }"
                @click="openUtm">
          <i class="icon icon--ga"></i>
          <label>{{ $t('journey.targeting.utm.step1.title') }}</label>
          <span class="check"></span>
        </button>
        <button class="survey" :class="{ active: journeyOptions.survey }"
                @click="openSurvey">
          <i class="icon icon--survey"></i>
          <label>{{ $t('journey.targeting.survey.title') }}</label>
          <span class="check"></span>
        </button>
        <button class="coming-soon">
          <span class="tooltip">
            {{ $t('common.comingSoon') }}
          </span>
          <i class="icon icon--ut"></i>
          <label>{{ $t('journey.targeting.ut.title') }}</label>
          <span class="check"></span>
        </button>
        <p class="description">
          {{ $t('journey.targeting.step0.onlyOne') }}
        </p>
      </div>
      <div class="select-footer">
        <ui-button @click="onCloseLayer">
          {{ $t('common.close') }}
        </ui-button>
      </div>
    </div>

    <utm-setting v-if="settingUtm"
                 :utmCache="utmCache"
                 :tag="tag"
                 @onSetUtm="onSetUtm"
                 @onCloseLayer="closeUtm" />

    <survey-setting v-if="settingSurvey"
                    :sessionCount="sessionCount"
                    :sessionTotalCount="sessionTotalCount"
                    @onSetSurvey="onSetSurvey"
                    @onCloseAll="onCloseLayer"
                    @onCloseLayer="closeSurvey" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UtmSetting from '@/components/journey/UtmSetting'
import SurveySetting from '@/components/journey/SurveySetting'

import UiButton from '@/components/ui/UiButton'

export default {
  name: 'Marketing',
  components: {
    UtmSetting,
    SurveySetting,
    UiButton
  },
  props: ['utmCache', 'tag', 'sessionCount', 'sessionTotalCount'],
  methods: {
    onSetSurvey (param) {
      this.$emit('onSetSurvey', param)
    },
    onSetUtm (param) {
      this.$emit('onSetUtm', param)
    },
    openUtm () {
      this.settingUtm = true
      this.settingSurvey = false
    },
    openSurvey () {
      this.settingUtm = false
      this.settingSurvey = true
    },
    closeUtm () {
      this.settingUtm = false
    },
    closeSurvey () {
      this.settingSurvey = false
    },
    onCloseLayer () {
      this.$emit('onCloseLayer')
    }
  },
  computed: {
    ...mapState([
      'domain',
      'journeyOptions'
    ])
  },
  data () {
    return {
      settingUtm: false,
      settingSurvey: false
    }
  }
}
</script>

<style lang="scss" scoped>
.marketing-setting {
  .select-segment {
    position: relative;
    width: 830px;
    height: 543px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #fff;

    .select-header {
      width: 770px;
      margin: 0 auto;
      padding: 42px 0 30px;
      border-bottom: 1px solid #bbb;

      .icon--close-size16 {
        position: absolute;
        top: 12px;
        right: 12px;
      }

      .select-title {
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        color: #444;
      }

      .select-description {
        margin-top: 12px;
        font-size: 13px;
        line-height: 1.08;
        text-align: center;
        color: #888;
      }
    }

    .select-body {
      text-align: center;
      margin: 75px 0 54px;

      button {
        position: relative;
        vertical-align: middle;
        width: 172px;
        height: 172px;
        margin: 0 10px;
        border-radius: 14px;
        border: solid 2px #afafaf;
        background-color: #fff;
        text-align: center;
        transition: box-shadow 0.2s ease, border-color 0.2s ease;

        &:not(.coming-soon):hover {
          box-shadow: 0 11px 17px -3px rgba(0, 0, 0, 0.25);
          border-color: #0274ff;

          .check {
            &::before {
              border-top-color: #0274ff;
            }
          }
        }

        .check {
          display: block;
          position: absolute;
          top: -1px;
          right: -1px;
          width: 56px;
          height: 56px;
          border-top-right-radius: 14px;
          overflow: hidden;
          opacity: 0;

          &::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 0;
            height: 0;
            border-left: 56px solid transparent;
            border-top: 56px solid #3eaa08;
            transition: border-top-color 0.2s ease;
          }

          &::after {
            content: "";
            position: absolute;
            top: 6px;
            right: 6px;
            width: 22px;
            height: 22px;
            background-size: 100% 100%;
            background-image: url(../../assets/img/common/icon--check-white-size20.svg);
          }
        }

        &.active {
          border-color: #3eaa08;

          .check {
            opacity: 1;
          }
        }

        .icon {
          width: 60px;
          height: 60px;
          background-size: 100% 100%;
        }

        label {
          display: block;
          font-size: 16px;
          line-height: 1.14;
          color: #767676;
          margin-top: 8px;
          cursor: pointer;
        }

        .tooltip {
          position: absolute;
          top: -12px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 12px;
          line-height: 1.08;
          color: #f2f2f2;
          padding: 5px 8px;
          border-radius: 3px;
          box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
          background-color: #1199af;
          white-space: nowrap;

          &::after {
            content: "";
            position: absolute;
            bottom: -5px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #1199af;
          }
        }

        &.coming-soon {
          overflow: visible;
          border-color: rgba(175, 175, 175, 0.3);
          cursor: default;

          .icon {
            opacity: 0.3;
          }

          label {
            opacity: 0.3;
          }
        }
      }

      .description {
        font-size: 13px;
        line-height: 1.54;
        color: #ec0047;
        margin: 40px 0;
      }
    }

    .select-footer {
      text-align: center;

      .ui-btn {
        width: 90px;
      }
    }
  }
  &.shared {
    button.survey {
      pointer-events: none;
      opacity: 0.3;
    }
  }
}
</style>
